import { useContext } from "react"
import { storageData } from "services/Services"
import AddressGaraged_Vehicles from "./AddressGaraged_Vehicles"
import "./AddressGaraged.css";

const AddressGaraged_Questions = ({ context, newAddressContext, vehicle, id, type }) => {
    var storedVehicles = context.addressChangeClass.vehicles.vehiclesOnPolicy?.storedVehicles

    // Updates vehicle with overnight location
    const updateVehicleLocation = (key, vehicle, id, value) => {
        // Sets/Resets the fields once checked
        if (key == "garaged") {
            vehicle["garagedStreetAddress"] = ""
            vehicle["garagedCity"] = ""
            vehicle["garagedState"] = ""
            vehicle["garagedZipCode"] = ""
        }

        vehicle[key] = value
        storedVehicles[id] = vehicle

        var addressClassCopy = context.addressChangeClass
        var storedVehiclesCopy = addressClassCopy.vehicles.vehiclesOnPolicy?.storedVehicles
        addressClassCopy.vehicles.vehiclesOnPolicy.storedVehicles = storedVehiclesCopy
        context.setAddressChangeClass({ ...addressClassCopy })
        // storageData.setItem("AddressChangeClass", JSON.stringify(context.addressChangeClass))
    }

    return (
        <>
            {/* Location of vehicle */}
            {newAddressContext?.newAddress?.garaged === "0" &&
                <div className="mb-3">
                    {/* Not Garaged */}
                    <p className="fw-bold text-primary my-2 field">
                        Which vehicles will not be garaged overnight at this address?
                    </p>

                    {/* Vehicles */}
                    {storedVehicles.map((vehicle, id) => {
                        return (
                            <div key={id} className="field">
                                <label className="mb-2">
                                    <input type="checkbox" style={{ verticalAlign: 'middle' }}
                                        checked={vehicle?.garaged ? vehicle?.garaged : ""}
                                        value={vehicle?.garaged ? vehicle?.garaged : ""}
                                        onChange={(e) => updateVehicleLocation("garaged", vehicle, id, e.target.checked)}
                                    />
                                    <span className="ms-3" style={checkBoxText}>
                                        {vehicle?.Year + " " + vehicle?.Make + " " + vehicle?.Model}
                                    </span>
                                </label>

                                {/* Displays Vehicles on Policy */}
                                {vehicle?.garaged &&
                                    <AddressGaraged_Vehicles
                                        vehicle={vehicle}
                                        id={id}
                                        updateVehicleLocation={updateVehicleLocation}
                                    />
                                }
                            </div>
                        )
                    })}
                </div>
            }
        </>
    )
}

const checkBoxText = {
    fontWeight: 'normal',
    cursor: 'pointer',
    verticalAlign: 'middle'
}

export default AddressGaraged_Questions